module.exports = __webpack_public_path__ + "img/example-fleets.e87f8df5.png";